import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["panel", "hamburger", "subItem", "subPanel"];

  toggle() {
    const isOpen = this.element.classList.contains("is-menu-open");
    if (isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.element.classList.add("is-menu-open");
    if (this.hasHamburgerTarget) {
      this.hamburgerTarget.setAttribute("aria-expanded", "true");
    }
    if (this.hasPanelTarget) {
      this.panelTarget.hidden = false;
    }
  }

  close() {
    this.element.classList.remove("is-menu-open");
    if (this.hasHamburgerTarget) {
      this.hamburgerTarget.setAttribute("aria-expanded", "false");
    }
    if (this.hasPanelTarget) {
      this.panelTarget.hidden = true;
    }
    this.subItemTargets.forEach(item => item.classList.remove("is-open"));
    this.subPanelTargets.forEach(panel => { panel.hidden = true; });
  }

  toggleSub(event) {
    const button = event.currentTarget;
    const item = button.closest("[data-homepage-mobile-menu-target~='subItem']");
    if (!item) return;

    const isOpen = item.classList.contains("is-open");

    this.subItemTargets.forEach(otherItem => {
      if (otherItem !== item && otherItem.classList.contains("is-open")) {
        otherItem.classList.remove("is-open");
        const otherButton = otherItem.querySelector("button");
        const otherPanel = otherItem.querySelector("[data-homepage-mobile-menu-target~='subPanel']");
        if (otherButton) otherButton.setAttribute("aria-expanded", "false");
        if (otherPanel) otherPanel.hidden = true;
      }
    });

    const subPanel = item.querySelector("[data-homepage-mobile-menu-target~='subPanel']");
    item.classList.toggle("is-open", !isOpen);
    button.setAttribute("aria-expanded", String(!isOpen));
    if (subPanel) subPanel.hidden = isOpen;
  }
}
